export const colorOptions = ['#F90404', '#0905F9', '#58A500', '#6800C4', '#F8E71C', '#50E3C2', '#F5A623', '#E10FA9'];
